module.exports = __webpack_public_path__ + "img/cross-circle-icon.f5114d3e.svg";